
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.665 2.398h-2.92v-.53A1.594 1.594 0 008.152.275H6.03A1.594 1.594 0 004.44 1.868v.53H1.52A1.329 1.329 0 00.192 3.725v1.858a.53.53 0 00.53.53h.29l.458 9.63a1.591 1.591 0 001.59 1.515h8.06a1.59 1.59 0 001.591-1.516l.459-9.629h.29a.53.53 0 00.53-.53V3.725a1.328 1.328 0 00-1.327-1.327zM5.5 1.868a.531.531 0 01.53-.53h2.122a.531.531 0 01.53.53v.53H5.5v-.53zM1.253 3.726a.265.265 0 01.266-.265h11.146a.265.265 0 01.265.265v1.327H1.254V3.726zm10.4 11.963a.53.53 0 01-.53.505h-8.06a.53.53 0 01-.53-.505L2.079 6.11h10.03l-.455 9.58z","fill":"#919191"}}),_c('path',{attrs:{"d":"M7.091 15.137a.53.53 0 00.53-.53v-6.9a.531.531 0 00-1.062 0v6.9a.53.53 0 00.53.53h.002zM9.745 15.137a.53.53 0 00.53-.53v-6.9a.53.53 0 10-1.062 0v6.9a.53.53 0 00.53.53h.002zM4.438 15.137a.53.53 0 00.53-.53v-6.9a.531.531 0 10-1.062 0v6.9a.53.53 0 00.53.53h.002z","fill":"#919191"}})])
          )
        }
      }
    